import React, { useEffect, useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import { connect, ConnectedProps } from 'react-redux';
import { Card, Tab, Tabs, Typography } from '@mui/material';
import { useIntl } from 'react-intl';

import { a11yProps, TabPanel } from '../../../../components/other/Tab/TabPanel';
import Preloader from '../../../../components/other/Preloader/Preloader';
import { ProfileForm } from '../components';
import { IAppState } from '../../../../store/rootDuck';
import { actions as profileActions } from '../../../../store/ducks/profile.duck';
import { setLayoutFooter, setLayoutSubheader } from '../../../../utils/layout';
import homeStyles from '../../../../constants/homeStyles';

const ProfileEditPage: React.FC<TPropsFromRedux> = ({ me, loadingMe, fetchMe }) => {
  const [valueTabs, setValueTabs] = useState(0);

  const homeClasses = homeStyles();
  const intl = useIntl();

  setLayoutSubheader({
    title: intl.formatMessage({ id: 'SUBMENU.PROFILE' }),
    breadcrumb: [],
  });
  setLayoutFooter({ show: true });

  useEffect(() => {
    fetchMe();
  }, []);

  const handleTabsChange = (_: any, newValue: number) => {
    setValueTabs(newValue);
  };

  if (!me || loadingMe) return <Preloader />;

  return (
    <Row>
      <Col>
        <Card className={homeClasses.classes.container}>
          <div className={homeClasses.classes.headerGradient} />
          <Tabs
            value={valueTabs}
            onChange={handleTabsChange}
            variant='scrollable'
            indicatorColor='primary'
            textColor='primary'
            aria-label='tabs'
          >
            <Tab
              label={intl.formatMessage({ id: 'SETTING.PROFILE.EDIT' })}
              {...a11yProps(0)}
            />
          </Tabs>
          <TabPanel value={valueTabs} index={0}>
            <Typography
              variant='h2'
              style={{ padding: '0 24px' }}
              className={homeClasses.classes.title}
            >
              {intl.formatMessage({ id: 'SUBMENU.PROFILE' })}
            </Typography>
            <ProfileForm me={me} />
          </TabPanel>
        </Card>
      </Col>
    </Row>
  );
};

const connector = connect(
  (state: IAppState) => ({
    me: state.profile.me,
    loadingMe: state.profile.loading,
  }),
  {
    fetchMe: profileActions.fetchRequest,
  }
);

type TPropsFromRedux = ConnectedProps<typeof connector>;

export default connector(ProfileEditPage);
